import React, { useState, useEffect } from 'react';
import FormInput from './FormInput';
import FormLabel from './FormLabel';
import PhoneNumberField from './PhoneNumberField';
import Button from './Button';
import FileUpload from './FileUpload';
import BlockTitle from './BlockTitle';
import ConfirmDialog from './ConfirmDialog';
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { firestore, storage } from "../lib/firebaseConfig";
import { useToast } from '../context/ToastContext';



const AddEditClient = ({ client = null, onSave, onCancel, investmentId, investmentStage, investmentTotalStages }) => {
  const { showError } = useToast();
  const [filePreviews, setFilePreviews] = useState({});
  const [buyerToRemove, setBuyerToRemove] = useState(null);

const allowedFields = [
  'name',
  'surname',
  'email',
  'flat',
  'gross_price',
  'installments',
  'buyers',
  'liczba_rat',
  'date',
  'net_price',
  'numer_rachunku',
  'umowa_deweloperska',
  'files'
];

const filterAllowedFields = (data) => {
  console.log("ta data bedzie filtrowana")
  console.log(data)
  const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key]) => allowedFields.includes(key))
  );
  return filteredData;
};

/*

buyers
: 
Array(1)
0
: 
{id: 83.45978915317528, name: 'Pawel', surname: 'Reszka', address: 'Kaszubska 4', pesel: '12312312', …}
length
: 
1
[[Prototype]]
: 
Array(0)
date
: 
"2025-05-08"
email
: 
""
files
: 
[]
flat
: 
"Rmr80BE0XpLSLkNcwjIo"
gross_price
: 
""
installments
: 
(4) [{…}, {…}, {…}, {…}]
liczba_rat
: 
""
name
: 
""
net_price
: 
"99998"
numer_rachunku
: 
"12343456789"
phone
: 
""
square
: 
""
surname
: 
""
umowa_deweloperska
: 
"test123"

*/

      const numInstallments = parseInt(investmentTotalStages - investmentStage + 2, 10) || 0;
      const percentagePerInstallment = 100 / numInstallments;
      const updatedInstallments = Array.from({ length: numInstallments }, (_, index) => {
        const amount = 0;
        const paymentNumber = index + 1;
        // stageNumber: 0 for initial payment, otherwise investmentStage + id - 2
        const stageNumber = paymentNumber === 1 ? 0 : investmentStage + paymentNumber - 2;

        return {
          id: paymentNumber,
          paymentNumber: paymentNumber,
          stageNumber: stageNumber,
          dueType: 'stage',            // "stage" | "fixed_date"
          linkedStage: stageNumber,     // which construction stage triggers this payment
          fixedDueDate: '',             // only used when dueType === "fixed_date"
          percentage: percentagePerInstallment.toFixed(2),
          amount: amount.toFixed(2),
          dueDate: '', // Will be set when stage completes
          payment_status: 'Do zapłaty',
          paidAmount: 0,
          remainingAmount: 0,
          reminder_dates: {
            first_reminder: '',
            second_reminder: '',
            third_reminder: '',
            final_reminder: '',
          },
          reminder_flags: {
            first_reminder: true,
            second_reminder: true,
            third_reminder: true,
            final_reminder: true,
          },
        };
      });
console.log("updatedInstallments");
console.log(updatedInstallments)
console.log(client)
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    phone: '',
    umowa_deweloperska: '',
    date: '',
    flat: '',
    square: '',
    buyers: [
      {
        id: Math.random() * 100,
        name: '',
        surname: '',
        address: '',
        pesel: '',
        buyerType: 'osoba_fizyczna',
        companyName: '',
        krs: '',
        nip: '',
        share: '',
      },
    ],
    ownershipType: 'sole', // sole | joint_marital | fractional
    maritalCommunity: false,
    net_price: '',
    gross_price: '',
    liczba_rat: '',
    installments: updatedInstallments, // Installments dynamically populated based on "liczba_rat"
    files: [], // Store uploaded files
  });

  const [availableFlats, setAvailableFlats] = useState([]);


  useEffect(() => {
    const fetchAvailableFlats = async () => {
      try {
        const investmentsSnapshot = await getDocs(collection(firestore, 'investments'));
        let flatsList = [];

        for (const investmentDoc of investmentsSnapshot.docs) {
          const investmentId = investmentDoc.id;
          const flatsRef = collection(firestore, `investments/${investmentId}/flats`);
          
          const availableFlatsQuery = query(flatsRef, where("status", "==", "available"));
          const flatsSnapshot = await getDocs(availableFlatsQuery);

          const filteredFlats = flatsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            investmentId,
          }));

          flatsList = [...flatsList, ...filteredFlats];
        }
        
        setAvailableFlats(flatsList);
      } catch (error) {
        console.error("Error fetching flats: ", error);
      }
    };

    fetchAvailableFlats();
  }, []);

/*
  // Populate form data if editing an existing client
useEffect(() => {
  if (client) {
    setFormData((prev) => ({
      ...prev,
      ...client,
      buyers: client.buyers || [],
      installments: client.installments || [],
    }));
  }
}, [client]);
*/
const uploadFilesToStorage = async (files, clientId) => {
  const uploadedFiles = [];
  
  for (const fileItem of files) {
    try {
      const fileName = `clients/${clientId}/${Date.now()}_${fileItem.file.name}`;
      const storageRef = ref(storage, fileName);
      
      await uploadBytes(storageRef, fileItem.file);
      const downloadURL = await getDownloadURL(storageRef);
      
      uploadedFiles.push({
        id: fileItem.id,
        name: fileItem.file.name,
        url: downloadURL,
        type: fileItem.file.type,
        uploadedAt: new Date().toISOString()
      });
      
      console.log(`File uploaded: ${fileItem.file.name}`);
    } catch (error) {
      console.error(`Error uploading file ${fileItem.file.name}:`, error);
    }
  }
  
  return uploadedFiles;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    let clientId = formData.id;
    
    // Step 1: Upload files to Firebase Storage first (if we have files)
    let uploadedFiles = [];
    if (formData.files && formData.files.length > 0) {
      // Generate temp clientId for new clients
      const tempClientId = clientId || `temp_${Date.now()}`;
      uploadedFiles = await uploadFilesToStorage(formData.files, tempClientId);
    }

    // Step 2: Prepare data with uploaded file URLs
    const cleanData = filterAllowedFields({
      ...formData,
      files: uploadedFiles
    });

    // Step 3: Save Client Data to Customers
    if (clientId) {
      const clientRef = doc(firestore, "customers", clientId);
      await updateDoc(clientRef, cleanData);
      console.log("Client updated: ", cleanData);
    } else {
      const clientRef = await addDoc(collection(firestore, "customers"), cleanData);
      clientId = clientRef.id;
      console.log("New client added with ID: ", clientRef.id);
    }

    // Step 2: Update Flat's Clients Array
    if (formData.flat) {
      const flatRef = doc(firestore, `investments/${investmentId}/flats/${formData.flat}`);
      const flatSnap = await getDoc(flatRef);
      
      if (flatSnap.exists()) {
        const flatData = flatSnap.data();
        const existingClients = flatData.clients || [];

        // Avoid duplicating client IDs
        const ownership = {
          type: formData.ownershipType || 'sole',
          maritalCommunity: !!formData.maritalCommunity,
          // Flat-level category: company if ANY buyer is a business (firma/JDG), else individuals
          buyerCategory: (formData.buyers || []).some((b) => b.buyerType === 'firma') ? 'company' : 'individual',
        };
        if (!existingClients.includes(clientId)) {
          await updateDoc(flatRef, {
            clients: [...existingClients, clientId],
            contract_number: formData.umowa_deweloperska,
            status: 'sold',
            ownership,
          });
          console.log(`Client ${clientId} added to flat ${formData.flat}.`);
        } else {
          await updateDoc(flatRef, {
            contract_number: formData.umowa_deweloperska,
            status: 'sold',
            ownership,
          });
        }
      }
    }

    // Step 3: Save Payments to Flat's Sub-Collection
    if (formData.installments && formData.flat) {
      for (const installment of formData.installments) {
        const paymentsRef = collection(
          firestore,
          `investments/${investmentId}/flats/${formData.flat}/payments`
        );
        // Calculate amount based on percentage and gross price
        const grossPrice = parseFloat(formData.gross_price) || 0;
        const percentage = parseFloat(installment.percentage) || 0;
        const calculatedAmount = (percentage / 100) * grossPrice;

        await addDoc(paymentsRef, {
          paymentNumber: installment.paymentNumber,
          stageNumber: installment.stageNumber,
          dueType: installment.dueType || 'stage',
          linkedStage: installment.linkedStage ?? installment.stageNumber,
          fixedDueDate: installment.fixedDueDate || '',
          percentage: percentage / 100, // Store as decimal (0.25 instead of 25)
          amount: calculatedAmount,
          dueDate: installment.dueDate || '',
          payment_status: 'Do zapłaty',
          paidAmount: 0,
          remainingAmount: calculatedAmount,
          withdrawnAmount: 0,
          paymentDates: '',
          dateField: '',
          clientId: clientId,
        });
        console.log("Payment added: ", installment.paymentNumber, "stageNumber:", installment.stageNumber);
      }
    }

    onSave(cleanData);
  } catch (error) {
    console.error("Error saving client: ", error);
    showError("Nie udało się zapisać danych klienta.");
  }
};




const onChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => {
    if (name === 'liczba_rat') {
      const numInstallments = parseInt(value, 10) || 0;
      const percentagePerInstallment = 100 / numInstallments;
      const updatedInstallments = Array.from({ length: numInstallments }, (_, index) => {
        const amount = (percentagePerInstallment / 100) * (parseFloat(prevData.net_price) || 0);
        
        return {
          id: index + 1,
          installment_number: index + 1,
          percentage: percentagePerInstallment.toFixed(2),
          amount: amount.toFixed(2),
          due_date: '',
          reminder_dates: {
            first_reminder: '',
            second_reminder: '',
            third_reminder: '',
            final_reminder: '',
          },
          reminder_flags: {
            first_reminder: true,
            second_reminder: true,
            third_reminder: true,
            final_reminder: true,
          },
        };
      });

      return {
        ...prevData,
        liczba_rat: value,
        installments: updatedInstallments,
      };
    }
    return { ...prevData, [name]: value };
  });
};

  const handleBuyerChange = (id, field, value) => {
    setFormData((prevData) => {
      const updatedBuyers = [...prevData.buyers];
      const index = updatedBuyers.findIndex((buyer) => buyer.id === id);
      updatedBuyers[index] = { ...updatedBuyers[index], [field]: value };
      return { ...prevData, buyers: updatedBuyers };
    });
  };

  const handleInstallmentChange = (id, value) => {
    setFormData((prevData) => {
      const updatedInstallments = prevData.installments.map((inst) =>
        inst.id === id ? { ...inst, percentage: value } : inst
      );
      return { ...prevData, installments: updatedInstallments };
    });
  };

  const addBuyer = () => {
    setFormData((prevData) => ({
      ...prevData,
      buyers: [
        ...prevData.buyers,
        {
          id: Math.random() * 100,
          name: '',
          surname: '',
          address: '',
          pesel: '',
          buyerType: 'osoba_fizyczna',
          companyName: '',
          krs: '',
          nip: '',
          share: '',
        },
      ],
    }));
  };

  const handleRemoveBuyerClick = (buyer) => {
    setBuyerToRemove(buyer);
  };

  const confirmRemoveBuyer = () => {
    if (buyerToRemove) {
      setFormData((prevData) => ({
        ...prevData,
        buyers: prevData.buyers.filter((buyer) => buyer.id !== buyerToRemove.id),
      }));
      setBuyerToRemove(null);
    }
  };

  const handleFileUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    const validFiles = selectedFiles
      .filter((file) => allowedTypes.includes(file.type))
      .map((file) => {
        const id = Date.now() + Math.random(); // Generate unique ID
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = () => {
            setFilePreviews((prevPreviews) => ({
              ...prevPreviews,
              [id]: reader.result,
            }));
          };
          reader.readAsDataURL(file);
        }
        return { id, file };
      });

    setFormData((prevData) => ({
      ...prevData,
      files: [...prevData.files, ...validFiles],
    }));
  };

  const handleRemoveFile = (id) => {
    setFormData((prevData) => ({
      ...prevData,
      files: prevData.files.filter((item) => item.id !== id),
    }));
  
    setFilePreviews((prevPreviews) => {
      const updatedPreviews = { ...prevPreviews };
      delete updatedPreviews[id];
      return updatedPreviews;
    });
  };

  const handleNumberInput = (e) => {
    let value = e.target.value;

    // Remove invalid characters (non-numeric and special characters like `-`).
    value = value.replace(/[^0-9]/g, '');

    // Prevent leading zeros
    if (value.startsWith('0')) value = value.replace(/^0+/, '');

    // Set the sanitized value
    e.target.value = value;
  };

  return (
    <div className="font-figtree max-h-[calc(100vh-40px)]">
      <BlockTitle className="text-[22px]">
        {client ? 'Edytuj klienta' : 'Dodaj klienta'}
      </BlockTitle>

      <form
        onSubmit={handleSubmit}
        className="grid max-600:block max-600:space-y-4 md:grid-cols-2 gap-4 mt-8 "
      >

        <div>
          <FormLabel htmlFor="umowa_deweloperska">Umowa deweloperska</FormLabel>
          <FormInput
            id="umowa_deweloperska"
            name="umowa_deweloperska"
            value={formData.umowa_deweloperska}
            onChange={onChange}
            placeholder="Podaj numer umowy deweloperskiej"
            required
          />
        </div>



        <div>
          <FormLabel htmlFor="date">Data</FormLabel>
          <FormInput
            id="date"
            type="date"
            name="date"
            value={formData.date}
            onChange={onChange}
            placeholder="Podaj datę podpisania"
            required
          />
        </div>

        <div>
          <FormLabel htmlFor="flat">Mieszkanie</FormLabel>
          <select
            id="flat"
            name="flat"
            value={formData.flat}
            onChange={onChange}
            required
            className="w-full border rounded-md px-3 py-2"
          >
            <option value="">Wybierz mieszkanie</option>
            {availableFlats.map(flat => (
              <option key={flat.id} value={flat.id}>
                {flat.code} - {flat.size}m²
              </option>
            ))}
          </select>
        </div>

        <div>
          <FormLabel htmlFor="numer_rachunku">Numer rachunku</FormLabel>
          <FormInput
            id="numer_rachunku"
            name="numer_rachunku"
            value={formData.numer_rachunku}
            onChange={onChange}
            placeholder="Podaj numer rachunku"
            required
          />
        </div>        
        <div className="col-span-2">
          <p className="block text-sm font-medium text-[var(--arsenic)]">
            Forma nabycia
          </p>
          <div className="px-3 py-2 border rounded-md grid grid-cols-2 gap-4 items-center">
            <FormLabel>
              Typ własności
              <select
                name="ownershipType"
                value={formData.ownershipType}
                onChange={onChange}
                className="w-full border rounded-md px-3 py-2"
              >
                <option value="sole">Jeden nabywca</option>
                <option value="joint_marital">Małżeństwo - wspólność ustawowa (bezudziałowo)</option>
                <option value="fractional">Udziały ułamkowe</option>
              </select>
            </FormLabel>
            <label className="flex items-center gap-2 text-sm text-[var(--arsenic)] mt-5">
              <input
                type="checkbox"
                checked={formData.maritalCommunity}
                onChange={(e) => setFormData((p) => ({ ...p, maritalCommunity: e.target.checked }))}
              />
              Wspólnota majątkowa małżeńska
            </label>
            <div className="col-span-2 text-xs text-gray-600">
              Kategoria nabywcy (poziom mieszkania):{' '}
              <span className="font-semibold">
                {(formData.buyers || []).some((b) => b.buyerType === 'firma') ? 'Firma / JDG' : 'Osoby fizyczne'}
              </span>
            </div>
          </div>
        </div>

        <div className="col-span-2">
          <p className="block text-sm font-medium text-[var(--arsenic)]">
            Nabywca
          </p>
          <div className="px-3 py-2 border rounded-md text-[var(--electric-blue)]">
            <div className="grid grid-cols-1">
              {formData.buyers.map((buyer) => (
                <div key={buyer.id} className="border-b last:border-b-0 pb-4 mb-4">
                  <div className="flex items-center gap-4 mb-2 flex-wrap">
                    <label className="flex items-center gap-1 text-sm">
                      <input
                        type="radio"
                        name={`btype-${buyer.id}`}
                        checked={(buyer.buyerType || 'osoba_fizyczna') !== 'firma'}
                        onChange={() => handleBuyerChange(buyer.id, 'buyerType', 'osoba_fizyczna')}
                      />
                      Osoba fizyczna
                    </label>
                    <label className="flex items-center gap-1 text-sm">
                      <input
                        type="radio"
                        name={`btype-${buyer.id}`}
                        checked={buyer.buyerType === 'firma'}
                        onChange={() => handleBuyerChange(buyer.id, 'buyerType', 'firma')}
                      />
                      Firma / JDG
                    </label>
                    {formData.ownershipType === 'fractional' && (
                      <span className="flex items-center gap-2">
                        <span className="text-sm">Udział:</span>
                        <FormInput
                          name="buyer_share"
                          value={buyer.share || ''}
                          onChange={(e) => handleBuyerChange(buyer.id, 'share', e.target.value)}
                          placeholder="1/2"
                        />
                      </span>
                    )}
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <FormLabel>
                      Numer telefonu
                      <PhoneNumberField
                        name="buyer_phone"
                        value={buyer.phone}
                        onChange={(e) =>
                          handleBuyerChange(buyer.id, 'phone', e.target.value)
                        }
                        placeholder="Podaj numer telefonu"
                        required
                      />
                    </FormLabel>

                    <FormLabel>
                      Email
                      <FormInput
                        name="buyer_email"
                        value={buyer.email}
                        onChange={(e) =>
                          handleBuyerChange(buyer.id, 'email', e.target.value)
                        }
                        placeholder="Podaj email nabywcy"
                        required
                      />
                    </FormLabel>

                    {buyer.buyerType === 'firma' ? (
                      <>
                        <FormLabel>
                          Nazwa firmy
                          <FormInput
                            name="buyer_companyName"
                            value={buyer.companyName || ''}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'companyName', e.target.value)
                            }
                            placeholder="Podaj nazwę firmy"
                            required
                          />
                        </FormLabel>

                        <FormLabel>
                          KRS
                          <FormInput
                            name="buyer_krs"
                            value={buyer.krs || ''}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'krs', e.target.value)
                            }
                            placeholder="Podaj numer KRS"
                          />
                        </FormLabel>

                        <FormLabel>
                          NIP
                          <FormInput
                            name="buyer_nip"
                            value={buyer.nip || ''}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'nip', e.target.value)
                            }
                            placeholder="Podaj NIP"
                            required
                          />
                        </FormLabel>

                        <FormLabel>
                          Adres siedziby
                          <FormInput
                            name="buyer_address"
                            value={buyer.address}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'address', e.target.value)
                            }
                            placeholder="Podaj adres siedziby"
                            required
                          />
                        </FormLabel>
                      </>
                    ) : (
                      <>
                        <FormLabel>
                          Imię nabywcy
                          <FormInput
                            name="buyer_name"
                            value={buyer.name}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'name', e.target.value)
                            }
                            placeholder="Podaj imię nabywcy"
                            required
                          />
                        </FormLabel>

                        <FormLabel>
                          Nazwisko nabywcy
                          <FormInput
                            id="buyer_surname"
                            name="buyer_surname"
                            value={buyer.surname}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'surname', e.target.value)
                            }
                            placeholder="Podaj nazwisko nabywcy"
                            required
                          />
                        </FormLabel>

                        <FormLabel>
                          Adres nabywcy
                          <FormInput
                            id="buyer_address"
                            name="buyer_address"
                            value={buyer.address}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'address', e.target.value)
                            }
                            placeholder="Podaj adres nabywcy"
                            required
                          />
                        </FormLabel>

                        <FormLabel>
                          PESEL nabywcy
                          <FormInput
                            type="number"
                            id="buyer_pesel"
                            name="buyer_pesel"
                            value={buyer.pesel}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'pesel', e.target.value)
                            }
                            onInput={handleNumberInput}
                            placeholder="Podaj pesel nabywcy"
                            required
                          />
                        </FormLabel>

                        <FormLabel>
                          NIP (jeśli dotyczy)
                          <FormInput
                            name="buyer_nip"
                            value={buyer.nip || ''}
                            onChange={(e) =>
                              handleBuyerChange(buyer.id, 'nip', e.target.value)
                            }
                            placeholder="Podaj NIP"
                          />
                        </FormLabel>
                      </>
                    )}

                    <Button
                      className="text-[var(--maroon)] font-medium pl-0 pt-0 pr-0 pb-0"
                      variant="flat"
                      onClick={() => handleRemoveBuyerClick(buyer)}
                    >
                      Usuń
                    </Button>
                  </div>
                </div>
              ))}
            </div>
            <Button
              className="mt-4 pt-[7px] pb-[7px] pl-[15px] pr-[15px]"
              type="button"
              onClick={addBuyer}
            >
              Dodaj nabywcę
            </Button>
          </div>
        </div>

        <div>
          <FormLabel htmlFor="net_price">Cena brutto</FormLabel>
          <FormInput
            id="net_price"
            type="number"
            min="1"
            name="net_price"
            value={formData.net_price}
            onChange={onChange}
            onInput={handleNumberInput}
            placeholder="Podaj cenę brutto"
            required
          />
        </div>



        {formData.installments.length > 0 && (
          <div className="col-span-2">
            <p className="block text-sm font-medium text-[var(--arsenic)]">
              Płatności
            </p>
            <div className="px-3 py-2 border rounded-md text-[var(--electric-blue)]">
              {formData.installments.map((installment) => (
                <div key={installment.id} className="mb-4">


                { installment.id === 1 ? (
                  <FormLabel>
                    Początkowa wpłata: procent ceny
                    <FormInput
                      type="number"
                      value={installment.percentage}
                      onChange={(e) =>
                        handleInstallmentChange(installment.id, e.target.value)
                      }
                      onInput={handleNumberInput}
                      placeholder="Podaj procent"
                      required
                    />
                  </FormLabel> )
                : (

                 <FormLabel>
                    Po etapie {investmentStage + installment.id - 2}: procent ceny
                    <FormInput
                      type="number"
                      value={installment.percentage}
                      onChange={(e) =>
                        handleInstallmentChange(installment.id, e.target.value)
                      }
                      onInput={handleNumberInput}
                      placeholder="Podaj procent"
                      required
                    />
                  </FormLabel>
                  )

              }

                </div>
              ))}
            </div>
          </div>
        )}

        <FileUpload
          files={formData.files}
          onChange={handleFileUpload}
          onRemoveFile={handleRemoveFile}
          filePreviews={filePreviews}
        />

        <div className="col-span-2 flex justify-end space-x-2 pb-8 mt-10">
          <Button type="submit" variant="default">
            Zapisz
          </Button>
          <Button type="button" variant="bordered" onClick={onCancel}>
            Anuluj
          </Button>

        </div>
      </form>

      <ConfirmDialog
        isOpen={buyerToRemove !== null}
        onConfirm={confirmRemoveBuyer}
        onCancel={() => setBuyerToRemove(null)}
        title="Usuń nabywcę"
        message={`Czy na pewno chcesz usunąć nabywcę ${buyerToRemove?.name || ''} ${buyerToRemove?.surname || ''}?`}
        confirmText="Usuń"
        cancelText="Anuluj"
        variant="danger"
      />
    </div>
  );
};

export default AddEditClient;
